import React, { useRef } from 'react';
import { Space, Row, Col, Switch, Tooltip } from 'antd';
import TableFetchData from '../../components/data-table/TableFetchData';
import MagazineCard from '../../components/magazine/MagazineCard';
import EditTableSvg from '../../assets/images/EditTable';
import DeleteTableSvg from '../../assets/images/DeleteTable';
import { useTranslation } from 'react-i18next';
import MagazineModal from '../../components/magazine/MagazineModal';
import { ImageNo } from '../../components/image/ImageComponent';
import { formatDateTime } from '../../utils/dateFormatUtils';
import { useNavigate } from 'react-router-dom';
import { putDataRequest } from '../../api/serviceMethods';
import { GALLERY_URL } from '../../api/URLs';
import MessageConfirmModal from '../../components/messageModal/MessageConfirmModal';
import TagTextComponent from '../../components/tag/TagTextComponent';

const TableListAvantGardeCreativity = ({ 
  viewType, magazineData, tableParams,
   setTableParams, loading, setLoading,
   hadleUpdateMagazine, deleteMagazineData, 
   initLoadProduct
}) => {
  const { t } = useTranslation();
   const messageModalRef = useRef('')
  // new code for view pdf
  const magazineRef = useRef();
  const appDownloadRef = useRef();
  const navigate = useNavigate();
  const maxLength = 25
  const handleShowMagazine = async (item) => {
    magazineRef.current?.showModal(item);
  };
  const handleCloseDownloadApp = () => appDownloadRef.current?.closeModal();

  const handleStatus = async (item) => {
    try {
      setLoading(true);
      await putDataRequest(`${GALLERY_URL}/${item.id}/status`, { status: !item.status } )
        .then((res) => {
          if (res.status === 200) {
            messageModalRef.current.showSuccessConfirmsAutoClose(t(res && res.message), () => { }, "", true);
            initLoadProduct('');
            setTimeout(() => {
              setLoading(false);
            }, 2000);
          } else {
            messageModalRef.current.showWarningConfirmsAutoClose(res && res.message, () => { }, "", true);
          }
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
          messageModalRef.current.showWarningConfirmsAutoClose(err && err.response && err.response.data && err.response.data.message || `Server Error!`, () => { }, "", true);
        });
    } catch (error) {
      setLoading(false)
      messageModalRef.current.showWarningConfirmsAutoClose(`Server Error!`, () => { }, "", true);
    }
  }


  const tableSettings = {
    appendable: false,
    removable: false,
    bordered: true,
    size: "small",
    pagination: {
      showLessItems: true,
      pageSize: 10,
    },
    columns: [
      {
        title: <label className="titleCard14400">{t("Photo")}</label>,
        render: (_, record) => (
          <img style={{ width: "80px", height: "85px", borderRadius: "6px", objectFit: "cover" }} src={record && record.images[0].url || ImageNo} />
        )
      },
      // {
      //   title: <label className="titleCard14400">{t("Product Name")}</label>,
      //   render: (_, record) => (
      //     <label className="text-capitalize">{record && record.name}</label>
      //   )
      // },
      {
        title: <label className="titleCard14400">{t("Type")}</label>,
        render: (_, record) => (
        <>
          <label className="text-capitalize">{record && record?.category || ""}</label>
        </>
      )
      },
      {
        title: <label className="titleCard14400">{t("Description")}</label>,
        render: (_, record) => {
          return <Tooltip title={record?.description}>
            {record?.description?.length > maxLength ? record?.description.slice(0, maxLength) + "..." : record?.description}
          </Tooltip>
        }
      },
      // {
      //   title: <label className="titleCard14400">{t("Description")}</label>,
      //   render: (_, record) => {
      //     return <Tooltip title={record?.description}>
      //       {record?.description?.length > maxLength ? record?.description.slice(0, maxLength) + "..." : record?.description}
      //     </Tooltip>
      //   }
      // },
      // {
      //   title: <label className="titleCard14400">{t('Product Price')}</label>,
      //   render: (_, record) => (
      //     <label className="text-capitalize">{`￥${record && record?.price}`}</label>
      //   )
      // },
      {
        title: <label className="ant-table-column-title titleCard14400">{t('Creation Time')}</label>,
        dataIndex: 'sortByDate',
        sorter: true,
        key: 'sortByDate',
        render: (_, record) => (
          <label className="text-capitalize">{record && record.createdTS && formatDateTime(record.createdTS)}</label>
        )
      },
      {
        title: <label className="titleCard14400">{t('Operator')}</label>,
        key: 'action',
        render: (_, record) => (
          <Space size="middle">
            <Switch onChange={() => handleStatus(record)} checked={record.status} />
            <span style={{ cursor: "pointer" }} onClick={() => navigate(`/avant-garde/${record._id}`)}>
              <EditTableSvg />
            </span>
            <span style={{ cursor: "pointer" }} onClick={() => deleteMagazineData(record)}>
              <DeleteTableSvg />
            </span>
          </Space>
        ),
      },
    ],
  };

  return (
    <div>
      <Row gutter={16} align="middle" style={{ marginBottom: 16 }}>
        <Col style={{ marginLeft: 'auto' }}>
        </Col>
      </Row>

      {viewType === 'table' ? (
        <TableFetchData
          tableParams={tableParams}
          setTableParams={setTableParams}
          data={magazineData}
          columns={tableSettings.columns}
          loading={loading}
          setLoading={setLoading}
        />
      ) : (
        <MagazineCard 
          magazineData={magazineData} setLoading={setLoading} 
          loading={loading} tableParams={tableParams}
          tableSettings={tableSettings}
          setTableParams={setTableParams}
          hadleUpdateMagazine={hadleUpdateMagazine}
          deleteMagazineData={deleteMagazineData}
          handleShowMagazine={handleShowMagazine}
          navigate={navigate}
          t={t}
        />
      )}
      <MagazineModal
        ref={magazineRef}
        handleCloseDownloadApp={handleCloseDownloadApp}
      />
      <MessageConfirmModal textCentered ref={messageModalRef} />
    </div>
  );
};

export default TableListAvantGardeCreativity;
